import Sidebar from '../shared/Sidebar'
import * as _ from '../../components/lodash'

export default class Archives
{
    constructor( )
    {
        this.$elem = $('.Archive')

        if( this.$elem.length > 0 ){
            let self = this
            
            this.$filters = this.$elem.find('.Archive__filters')
            this.$results = this.$elem.find('.Archive__results')

            $(document).ready(function(){
                self._generatePagination()
                Archives._adjustSizesItems()

                $.each(self.$results.find('.item-not-primary'), function( i,val ){
                    let currentText = $(this).find('.item__content p').text()

                    let newText = _.truncate(currentText, {
                        'length': 140,
                        'separator': '...'
                    })

                    $(this).find('.item__content p').text(newText)
                })
            })

            $(window).resize( ()=> {
                Archives._adjustSizesItems()
            })

            $(window).on("orientationchange", ()=> {
                Archives._adjustSizesItems()
            })

            $( window ).scroll( ()=> {

            })
        }
    }

    _generatePagination()
    {
        $.each($('.Archive__results').children(':not(.loader_theme)'), function( i,val ){
            let itemForPagination = 0

            if (window.innerWidth >= 768) {
                itemForPagination = 5
                if (window.innerWidth >= 1024) {
                    itemForPagination = 8
                }
            }
            else {
                itemForPagination = 4
            }

            let attr = $(this).attr('data-type')


            /*if ($(this).find('.item_page').length > itemForPagination) {
                $('.' + attr).gPages({
                    item: '.item_page',
                    itemPerPage: itemForPagination,
                    loader: 'dots',
                    prevText: '',
                    prevSrc: theme_url + '/images/icons/chevron_left_gray.svg',
                    nextText: '',
                    nextSrc: theme_url + '/images/icons/chevron_right_gray.svg',
                    pageChange: function () {
                        let valueScrollTop = $('.HeaderPage').height() - $('#header').height()

                        $('html, body').stop().animate({scrollTop: valueScrollTop}, '500', 'swing', function () {
                        })

                        setTimeout(function () {
                            //Sidebar.resizeContainer()
                        }, 400)

                        setTimeout(function () {
                            //Sidebar.resizeContainer()
                        }, 2100)
                    }
                })

                $.each($(this).find('.gPage'), function (i, val) {
                    if ($(this).children().length > 1) {
                        $(this).append('<div class="container-others grid-noGutter-top-left"></div>')
                        $(this).find('.container-others').append($(this).children().first().siblings())
                    }

                    if ($(this).children('.item-primary').length < 1) {
                        $(this).children().removeClass('item-primary')

                        let template = $(this).parents('.Archive__results').find('.item-primary').clone(),
                            $item = $(this).children().first()

                        let link = $item.children('a').attr('href'),
                            date = $item.find('.item__header .date').html(),
                            title = $item.find('.item__header h2').text(),
                            srcImage = $item.find('.item__thumbnail img').attr('src'),
                            extract = $item.find('.item__content p').text()

                        template.find('.item__link').add(template.find('.item__content .link')).attr('href', link)
                        template.find('.item__content .date').html(date)
                        template.find('.item__content h2').text(title)
                        template.find('.item__thumbnail img').attr('src', srcImage)
                        template.find('.item__content p').text(extract)

                        if ($(this).children().length > 1) {
                            template.first().insertBefore($item.siblings())
                        }
                        else {
                            $item.parent().append(template[0])
                        }

                        template.show()
                        $item.remove()
                    }
                })
            }*/
        })
    }

    static _adjustSizesItems()
    {
        let $results = $('.Archive__results').children(':not(.loader_theme).active')

        let resizer = ( items ) => {
            let maxHeight = 0
            $.each(items, function( i,val ){
                let value = 0
                value = $(this).find('.item__header').children().first().outerHeight() + 25
                value += $(this).find('.item__header').children().last().outerHeight()

                if( value >= maxHeight ){
                    maxHeight = value
                }

                $(this).find('.item__thumbnail .item__thumbnail__box').css({
                    //'width': $(this).find('.item__thumbnail > img').width(),
                    //'height': $(this).find('.item__thumbnail > img').height()
                })

                if( i + 1 == items.length ){
                    if( window.innerWidth >= 768 ){
                        items.find('.item__header').css({
                            'height' : maxHeight
                        })
                    }
                    else{
                        let attr = items.first().find('.item__header').attr('style')

                        if (typeof attr !== typeof undefined && attr !== false) {
                            items.find('.item__header').removeAttr('style')
                        }
                    }
                }
            })
        }

        resizer( $results.find('.item-not-primary') )
    }
}
